/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PurchaseCostCoverageOrderData } from './PurchaseCostCoverageOrderData';
import {
    PurchaseCostCoverageOrderDataFromJSON,
    PurchaseCostCoverageOrderDataFromJSONTyped,
    PurchaseCostCoverageOrderDataToJSON,
    PurchaseCostCoverageOrderDataToJSONTyped,
} from './PurchaseCostCoverageOrderData';

/**
 * 
 * @export
 * @interface PurchaseCostCoverageData
 */
export interface PurchaseCostCoverageData {
    /**
     * 
     * @type {number}
     * @memberof PurchaseCostCoverageData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseCostCoverageData
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseCostCoverageData
     */
    totalOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseCostCoverageData
     */
    totalMissingLines?: number;
    /**
     * 
     * @type {Array<PurchaseCostCoverageOrderData>}
     * @memberof PurchaseCostCoverageData
     */
    orders?: Array<PurchaseCostCoverageOrderData>;
}

/**
 * Check if a given object implements the PurchaseCostCoverageData interface.
 */
export function instanceOfPurchaseCostCoverageData(value: object): value is PurchaseCostCoverageData {
    return true;
}

export function PurchaseCostCoverageDataFromJSON(json: any): PurchaseCostCoverageData {
    return PurchaseCostCoverageDataFromJSONTyped(json, false);
}

export function PurchaseCostCoverageDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseCostCoverageData {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'totalOrders': json['totalOrders'] == null ? undefined : json['totalOrders'],
        'totalMissingLines': json['totalMissingLines'] == null ? undefined : json['totalMissingLines'],
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(PurchaseCostCoverageOrderDataFromJSON)),
    };
}

export function PurchaseCostCoverageDataToJSON(json: any): PurchaseCostCoverageData {
    return PurchaseCostCoverageDataToJSONTyped(json, false);
}

export function PurchaseCostCoverageDataToJSONTyped(value?: PurchaseCostCoverageData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'pageSize': value['pageSize'],
        'totalOrders': value['totalOrders'],
        'totalMissingLines': value['totalMissingLines'],
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(PurchaseCostCoverageOrderDataToJSON)),
    };
}

